import React, { useState, useEffect, useRef } from 'react'
// import './common.css'
import Services from './Services'
import { themeConfig } from '../Testimonials/config/themeConfig'
import { getServicesArray } from '../../../utils/utility'

const ServiceWrapper = ({ themeData, isExt, theme, templateData }) => {
    const selectedTheme = themeConfig[theme]
    const [services, setServices] = useState([]);
    


  useEffect(() => {
        if (themeData?.serviceObj?.content) {
            console.log("ppppp")
            setServices(getServicesArray(themeData?.serviceObj?.content));
        } else if(themeData?.servicesArray?.length && !isExt){
            console.log("qqqq")
            setServices(getServicesArray(themeData?.servicesArray));
        }  else if(!themeData && !isExt){
            setServices(templateData)
        }else {
            console.log("rrrr")
            setServices([]);
        }
    }, [themeData]);




    let data = {
        themeData,
        isExt,
        selectedTheme,
        theme,
        services
    }
    return (
        <>
           <Services {...data}/>
        </>
    )
}

export default ServiceWrapper